import * as React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import { ReactComponent as CalendarIcon } from '../assets/svg/calendar.svg';

interface DateDayExpiryInputTypes {
	dateTimeString: string;
	onChange?: any;
	showDropdowns?: boolean;
	excludeFuture?: boolean;
	excludePast?: boolean;
	className?: string;
	disabled?: boolean;
}

export const DateDayExpiryInput: React.FC<DateDayExpiryInputTypes> = ({
	dateTimeString,
	onChange,
	showDropdowns = false,
	excludeFuture = false,
	excludePast = false,
	className,
	disabled = false
}) => {
	const [dateTimeObject, setDateTimeObject] = React.useState<Date>();
	const [minDate, setMinDate] = React.useState<Date | null>(null);
	const [maxDate, setMaxDate] = React.useState<Date | null>(null);

	// date comes in as a string: 2022-04-22T11:28:07.1994149+10:00
	// date is returned as a date object
	const parseDate = (str: string) => {
		const parsedDate = moment(str, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ');
		const newDate = parsedDate.isValid() ? parsedDate.toDate() : new Date();

		return newDate;
	};

	// date is returned as a string: 2022-04-22T11:28:07
	const returnDateTime = (obj: Date) => {
		// do not return the timezone offset
		const dateStr = moment(obj).format('YYYY-MM-DDTHH:mm:ss');

		if (onChange) {
			onChange(dateStr);
		}
	};

	const handleDateChange = (date: Date) => {
		date = date || new Date();
		// changing date to the last second of the selected month
		date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);

		setDateTimeObject(date);
	};

	React.useEffect(() => {
		if (dateTimeString) {
			const currentDate = parseDate(dateTimeString);
			setDateTimeObject(currentDate);
		}
	}, [dateTimeString]);

	React.useEffect(() => {
		if (dateTimeObject) {
			returnDateTime(dateTimeObject);
		} else {
			//pass back the null value
			if (onChange) {
				onChange('');
			}
		}
	}, [dateTimeObject]);

	React.useEffect(() => {
		const now = new Date();

		if (excludePast) {
			setMinDate(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0));
		}

		if (excludeFuture) {
			setMaxDate(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 11, 59, 59));
		}
	}, []);

	return (
		<div className="row form-row">
			<div className="col-12">
				<div className="form-control date-picker">
					<CalendarIcon />
					<DatePicker
						dateFormat="dd/MM/yyyy"
						selected={dateTimeObject}
						onChange={(date: Date) => handleDateChange(date)}
						placeholderText="DD/MM/YYYY"
						className={`form-control ${className}`}
						showMonthDropdown={showDropdowns}
						showYearDropdown={showDropdowns}
						dropdownMode="select"
						minDate={minDate}
						maxDate={maxDate}
						disabled={disabled}
					/>
				</div>
			</div>
		</div>
	);
};

export default DateDayExpiryInput;
